import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AccreditationBody, Scope} from "../../store/state/order.state";
import {filter, first, map, mergeMap} from "rxjs/operators";
import {EndpointsProvider} from "../../umbrella-common/endpoints/endpoint-provider.service";
import {Store} from "@ngrx/store";
import {AppState} from "../../store/state/app.state";
import {orderSelector} from "../../store/state/state.selectors";

@Injectable()
export class ScopesFetchService {

	constructor(private endpoints: EndpointsProvider, private store: Store<AppState>) {
	}

	fetchScopes(): Observable<{ [accBody: string] : Scope[] }> {
		return this.store.select(orderSelector).pipe(
            filter(order => order.clientCountry!= null),
            first(),
			map(order => order.products.map(p => p.accreditationBody)),
			mergeMap((accBodies: AccreditationBody[]) => this.endpoints.common.getScopes(accBodies)),
			map((scopeMap: { [accBody: string] : Scope[] }) => {
				return Object.keys(scopeMap).reduce((previous, accBody) => {
					let target: { [accBody: string] : Scope[] } = { [accBody]: scopeMap[accBody].sort((s1, s2) => this.compareScopes(s1, s2)) };
					return Object.assign(target, previous);
				}, {});
			})
		);
	}

	private compareScopes(scope1: Scope, scope2: Scope): number {
		if (this.scopeCodeContainsDotCharacter(scope1) && !this.scopeCodeContainsDotCharacter(scope2)) {
			return 1;
		} else if (!this.scopeCodeContainsDotCharacter(scope1) && this.scopeCodeContainsDotCharacter(scope2)) {
			return -1;
		} else if (this.scopeCodeContainsDotCharacter(scope1) && this.scopeCodeContainsDotCharacter(scope2)) {
			// both not numbers, e.g. scope1 = a.1 scope2 = a.2:
			return this.compareNumbers(this.getLastNumberFromScopeCode(scope1), this.getLastNumberFromScopeCode(scope2));
		} else {
			// both numbers, e.g. scope1 = 1 scope2 = 2:
			return this.compareNumbers(Number(scope1.code), Number(scope2.code));
		}
	}

	private compareNumbers(n1: number, n2: number): number {
		return n1 === n2 ? 0 : (n1 > n2 ? 1 : -1);
	}

	private scopeCodeContainsDotCharacter(scope: Scope): boolean {
		return scope.code.indexOf(".") >= 0;
	}

	private getLastNumberFromScopeCode(scope: Scope): number {
		const code = scope.code;
		return Number(code.substr(code.lastIndexOf(".") + 1, code.length - 1));
	}
}
